import React from "react";

const STEPS = [
  { id: "rsvp", label: "RSVP" },
  { id: "floor", label: "On floor" },
  { id: "vote", label: "Vote" },
];

export default function DemoProgress({ current = 1, completed = {} }) {
  return (
    <nav
      className="mb-5"
      aria-label="Demo progress"
      data-testid="demo-progress"
    >
      <ol className="flex items-center gap-1">
        {STEPS.map((step, index) => {
          const stepNum = index + 1;
          const isCurrent = stepNum === current;
          const isDone = completed[step.id] || stepNum < current;

          return (
            <li key={step.id} className="flex items-center gap-1 flex-1 min-w-0">
              <span
                className={`flex items-center gap-1.5 min-w-0 font-ui text-[12px] font-medium leading-tight ${
                  isCurrent ? "text-ink" : isDone ? "text-ink/70" : "text-ink/45"
                }`}
                aria-current={isCurrent ? "step" : undefined}
              >
                <span
                  className={`shrink-0 w-6 h-6 rounded-full grid place-items-center text-[11px] font-semibold ${
                    isCurrent
                      ? "bg-ink text-white"
                      : isDone
                        ? "bg-ink/10 text-ink"
                        : "bg-black/[0.06] text-ink/50"
                  }`}
                  aria-hidden
                >
                  {isDone && !isCurrent ? "✓" : stepNum}
                </span>
                <span className="truncate">{step.label}</span>
              </span>
              {index < STEPS.length - 1 && (
                <span
                  className={`h-px flex-1 min-w-[8px] ${isDone ? "bg-ink/20" : "bg-black/[0.08]"}`}
                  aria-hidden
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
